module.exports = __webpack_public_path__ + "media/images/admin/button_types-e48a9898076b47686491136acfe34ef4.png";